import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import ErrorIcon from '@material-ui/icons/Error';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { CookiesProvider } from 'react-cookie';
import App from './App';
import theme from './theme';
import { unregister } from './registerServiceWorker';
import SnackbarCloseButton from './components/global/SnackbarClose';
import BugHerd from './components/global/BugHerd';
import SwrWrapper from './lib/swrWrapper';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0) - 75;

const scrollToPath = (event) => {
  if (event.target.getBoundingClientRect().bottom > (vh)) {
    window.scrollBy(0, 80);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('focusin', (event) => scrollToPath(event));
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={baseUrl}>
      <BugHerd />
      <CookiesProvider>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <ThemeProvider theme={theme}>
            <SnackbarProvider
              dense
              action={(closeKey) => <SnackbarCloseButton closeKey={closeKey} />}
              maxSnack={5}
              anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
              iconVariant={{
                error: <ErrorIcon fontSize="medium" style={{ paddingRight: '.5rem' }} />,
              }}
            >
              <SwrWrapper>
                <App />
              </SwrWrapper>
            </SnackbarProvider>
          </ThemeProvider>
        </MuiPickersUtilsProvider>
      </CookiesProvider>
    </BrowserRouter>
  </React.StrictMode>,
  rootElement,
);

unregister();
